(function ($) {
    $.extend(true, FormData, {
        // this dateFormats is for using in Samples only
        Samples: {
            // pickerFormat will be used for jQuery datepicker validation,
            // while friendlyFormat will show in validation message for user.
            DateFormats: {
                "en-us": {
                    "pickerFormat": "mm/dd/yy",
                    "friendlyFormat": "MM/dd/yyyy"
                },
                "sv-se": {
                    "pickerFormat": "yy-mm-dd",
                    "friendlyFormat": "yyyy-MM-dd"
                },
                "nb-no": {
                    "pickerFormat": "dd.mm.yy",
                    "friendlyFormat": "dd.MM.yyyy"
                },
                "da-dk": {
                    "pickerFormat": "dd-mm-yy",
                    "friendlyFormat": "dd-MM-yyyy"
                },
                "de-de": {
                    "pickerFormat": "dd.mm.yy",
                    "friendlyFormat": "dd.MM.yyyy"
                },
                "nl-nl": {
                    "pickerFormat": "d-m-yy",
                    "friendlyFormat": "d-M-yyyy"
                },
                "fi-fi": {
                    "pickerFormat": "d.m.yy",
                    "friendlyFormat": "d.M.yyyy"
                },
                "fr-fr": {
                    "pickerFormat": "dd/mm/yy",
                    "friendlyFormat": "dd/MM/yyyy"
                }
            }
        }
    });
    var _utilsSvc = FormData.Utils,
        language = navigator.language || navigator.userLanguage, // on iOS naviagtor.language is in lower case (ex: en-us)
        dateFormatSettings = FormData.Samples.DateFormats[language.toLowerCase()] || FormData.Samples.DateFormats["en-us"],
        dateFormat = dateFormatSettings.pickerFormat;

    // init all DateTimeFormElement on the ViewMode with our modified jQuery DatePicker
    if (typeof __SamplesDateTimeElements != "undefined") {
        $.each(__SamplesDateTimeElements || [], function (i, dateTimeElementInfo) {

            var element = $("#" + dateTimeElementInfo.guid);

            var maxDate = "+10Y";
            var minDate = "-1";

            switch (dateTimeElementInfo.allowedDate) {
                case "futuredatesonly":
                    maxDate = "+10Y";
                    minDate = "+1D";
                    break;
                case "futuredatesonlyonemonthahead":
                    maxDate = "+10Y";
                    //minDate = "+30D";
                    minDate = "+" + getRemainingDays() + "D"; 
                    break;
                case "pastdatesonly":
                    maxDate = "-1D";
                    minDate = "-100Y";
                    break;
                default:
                    maxDate = "+10Y";
                    minDate = "-100Y";
                    break;
            }

            // setup picker
            element.datetimepicker({
                type: dateTimeElementInfo.pickerType,
                constrainInput: false,
                dateFormat: dateFormat,
                changeMonth: true,
                changeYear: true,
                maxDate: maxDate,
                minDate: minDate,
                yearRange: "-100:+10Y"
            });

            // format datetime value to match with current culture 
            formatDateTimeValue(element, dateTimeElementInfo.pickerType);
        });

        function formatDateTimeValue(element, pickerType) {
            // reformat auto fill value
            var elementValue = element.val();
            if (elementValue) {
                switch (pickerType) {
                    case "datepicker":
                        element.datetimepicker('setDate', new Date(elementValue)); // this will set date only
                        break;
                    case "datetimepicker":
                        var dateTimeSegments = elementValue.split(" ");

                        if (dateTimeSegments.length === 3) {
                            element.datetimepicker('setDate', new Date(dateTimeSegments[0])); // this will set date only
                            element.val(element.val() + " " + dateTimeSegments[1] + " " + dateTimeSegments[2]);
                        }
                        break;
                }
            }
        }

        function getRemainingDays() {
            var date = new Date();
            var time = new Date(date.getTime());
            time.setMonth(date.getMonth() + 1);
            time.setDate(0);
            var days = time.getDate() > date.getDate() ? time.getDate() - date.getDate() : 0;
            console.log("days: " + days);
            return days + 1;
        }

        $('.EPiServerForms .Form__CustomInput.FormDateTime__Input').on('keydown', function _onKeyDown(e) {
            return _utilsSvc.showNextStepOnEnterKeyDown(e);
        });
    }

})($$epiforms || $);